

import React from 'react';
import AppRoutes from './routes/AppRoutes';
import './styles/global.css';
import { SocketProvider } from './utils/SocketContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function App() {
  return (
    <SocketProvider>
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
    </SocketProvider>
  );
}

export default App;
